import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { ContrastChecker } from "../components/ContrastChecker";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.cc_tool_name()}
        toolPath="/contrast-checker"
      />
      <SciHeader title={m.cc_h1()} intro={m.cc_intro()} />
      <ContrastChecker />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.cc_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.cc_ex1(), m.cc_ex2(), m.cc_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.cc_faq_q1(), a: m.cc_faq_a1() },
          { q: m.cc_faq_q2(), a: m.cc_faq_a2() },
          { q: m.cc_faq_q3(), a: m.cc_faq_a3() },
          { q: m.cc_faq_q4(), a: m.cc_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
